import { useAppSelector } from './redux-hooks';

// Ordering is switched on per restaurant by a TLG super-admin and reaches
// us on the menu payload. Anything other than an explicit true — a menu
// still loading, an older backend, a restaurant without the feature —
// means no cart, no checkout.
export function useOrderingEnabled(): boolean {
    return useAppSelector((state) => state.menu.menu?.featureOrdering === true);
}
